import { render } from "./ReportingPolicy.vue?vue&type=template&id=60b0af1a&scoped=true&ts=true"
import script from "./ReportingPolicy.vue?vue&type=script&lang=ts"
export * from "./ReportingPolicy.vue?vue&type=script&lang=ts"

import "./ReportingPolicy.vue?vue&type=style&index=0&id=60b0af1a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b0af1a"]])

export default __exports__